import { __assign } from "tslib";
export var seoApiRelativePath = "/helpcenter/seo";
export var createSeoApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl).concat(seoApiRelativePath);
    return {
        getPageSeo: function (dto) {
            return http.get("".concat(apiUrl, "/").concat(dto.type, "/").concat(dto.locale).concat(dto.brandId ? "?brandId=".concat(dto.brandId) : ''));
        },
        updatePageSeo: function (dto) {
            return http.post("".concat(apiUrl, "/").concat(dto.type, "/").concat(dto.locale), dto.brandId ? __assign(__assign({}, dto.data), { brandId: dto.brandId }) : dto.data);
        }
    };
};
//# sourceMappingURL=index.js.map